;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _vueFormWizard = require("vue-form-wizard");

var _vueFormWizard2 = _interopRequireDefault(_vueFormWizard);

var _vuelidate = require("vuelidate");

var _vuelidate2 = _interopRequireDefault(_vuelidate);

var _validators = require("vuelidate/lib/validators");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.use(_vuelidate2.default);
Vue.use(_vueFormWizard2.default);
exports.default = {
  data: function data() {
    return {
      email_already_taken: true,
      idno_already_taken: true,
      phone_already_taken: true,
      merchant_name_already_taken: true,
      business_verified: null,
      business_verifying: null,
      business: null,
      services: null,
      selected_service: [],
      fname_error: null,
      lname_error: null,
      idno_error: null,
      phone_error: null,
      email_error: null,
      errorMsg: null,
      iprs_details: null,
      iprs_verifying: null,
      iprs_details_verified: null,
      customerForm: {
        fname: null,
        lname: null,
        idno: null,
        phone: null,
        email: null
      },
      businessForm: {
        bname: "",
        bregno: null,
        baddr: null,
        btaxpin: null,
        bphone: null
      },
      consumer_secret: null,
      consumer_key: null,
      api_token: null,
      merchant_id: null,
      agent_type: "Yes",
      retrieved_business_data: null
    };
  },

  validations: {
    customerForm: {
      fname: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(2)
      },
      lname: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(2)
      },
      idno: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(4),
        alreadyTaken: function alreadyTaken(value) {
          if (value === "" || value == null) return true;
          return this.confirmIfIdnoAlreadyTaken(value);
        }
      },
      phone: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(3),

        onlyDigitsAllowed: function onlyDigitsAllowed(value) {
          if (value === "" || value == null) return true;
          return this.confirmOnlyDigits(value);
        },
        alreadyTaken: function alreadyTaken(value) {
          if (value === "" || value == null) return true;
          return this.confirmIfPhoneAlreadyTaken(value);
        }
      },
      email: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(4),
        isValidEmail: function isValidEmail(value) {
          if (value === "" || value == null) return true;
          return this.validEmail(value);
        },
        alreadyTaken: function alreadyTaken(value) {
          if (value === "" || value == null) return true;
          return this.confirmIfEmailAlreadyTaken(value);
        }
      }
    },
    businessForm: {
      bname: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(4),
        alreadyTaken: function alreadyTaken(value) {
          if (value === "" || value == null) return true;
          return this.confirmMerchantNameAlreadyTaken(value);
        }
      },
      bregno: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(6)
      },
      baddr: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(4)
      },
      btaxpin: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(9)
      },
      bphone: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(12),
        isValidPhone: function isValidPhone(value) {
          if (value === "" || value == null) return true;
          return this.confirmOnlyDigits(value);
        }
      }
    }
  },
  mounted: function mounted() {
    this.set_explanation("none");
  },
  methods: {
    set_explanation: function set_explanation(xtype) {
      if (xtype == "none") {
        this.explanation = "Creates a merchant account, so you can transact as a merchant";
      } else if (xtype == "pesaflow") {
        this.explanation = "Creates a merchant and agent account, so you can transact as a merchant as well as an agent, accessing all services from Pesaflow";
      } else {
        this.explanation = "Creates a merchant and agent account, so you can transact as a merchant as well as an agent";
      }
    },
    reset_verified: function reset_verified() {
      this.iprs_details_verified = false;
      this.business_verified = false;
    },
    validateCustomerDetailsStep: function validateCustomerDetailsStep() {
      if (this.$v.customerForm.$invalid) {
        return false;
      }
      return true;
    },


    validEmail: function validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    validPhone: function validPhone(phone) {
      var re = /^(254)\d{9}$/;
      return re.test(phone);
    },

    confirmOnlyDigits: function confirmOnlyDigits(phone) {
      var re = /^\d+$/;
      return re.test(phone);
    },

    validPhoneLength: function validPhoneLength(phone) {
      var re = /d{9}$/;
      return re.test(phone);
    },

    validateBusinesDetailsStep: function validateBusinesDetailsStep() {
      if (this.$v.businessForm.$invalid) {
        return false;
      }
      return true;
    },
    invalidate_business_details: function invalidate_business_details() {
      this.businessForm.bname = null;
      this.businessForm.email = null;
      this.businessForm.btaxpin = null;
      this.businessForm.bphone = null;
      this.businessForm.baddr = null;
      this.businessForm.bregno = null;
    },
    validate_business: function validate_business() {
      var _this = this;

      if (this.businessForm.bregno == null || this.businessForm.bname == null || this.businessForm.bname === "") {
        _sweetalert2.default.fire({
          icon: "error",
          text: "Please provide business name and business registration number!"
        });
        return;
      }
      var url = "/api/business/lookup";
      var payload = {
        registration_number: this.businessForm.bregno
      };
      this.business_verifying = true;
      Vue.axios.post(url, payload).then(function (response) {
        var status = response.data.status;
        if (status == "ok") {
          var business_data = response.data.business;

          if (business_data.verified) {
            if (_this.businessForm.bname.toLowerCase() == business_data.business_name.toLowerCase()) {
              _this.businessForm.bname = business_data.business_name;
              _this.businessForm.email = business_data.email;
              _this.businessForm.btaxpin = business_data.kra_pin;
              _this.businessForm.bphone = business_data.phone_number;
              _this.businessForm.baddr = business_data.postal_address;
              _this.businessForm.bregno = business_data.registration_number;
              _this.business_verified = true;
            } else {
              _this.business_verified = false;
              _this.invalidate_business_details();
              _sweetalert2.default.fire({
                icon: "error",
                text: "Verification failed!. Please check your business details !"
              });
            }
          } else {
            _this.business_verified = false;
            _this.invalidate_business_details();
            _sweetalert2.default.fire({
              icon: "error",
              text: "We are unable to verify your business details. Please check if business registration is valid !"
            });
          }
        } else {
          _this.business_verified = false;
          _this.invalidate_business_details();
          _sweetalert2.default.fire({
            icon: "error",
            text: response.data.message
          });
        }
        _this.business_verifying = !true;
      }).catch(function (error) {
        _this.business_verified = false;
        _this.business_verifying = !true;
        _this.invalidate_business_details();
        _sweetalert2.default.fire({
          icon: "error",
          text: "We are unable to verify your business details. Please try again later."
        });
      });
    },

    validate_iprs: function validate_iprs() {
      var _this2 = this;

      if (this.customerForm.idno == null || this.customerForm.fname == null) {
        _sweetalert2.default.fire({
          icon: "error",
          text: "Some details that are required may be missing !"
        });
      }
      var url = "/api/customer/verification/validate";
      var payload = {
        id_number: this.customerForm.idno,
        first_name: this.customerForm.fname,
        last_name: this.customerForm.lname
      };
      this.iprs_verifying = true;
      Vue.axios.post(url, payload).then(function (response) {
        var status = response.data.verified;
        if (status) {
          _this2.iprs_details_verified = true;
        } else {
          _this2.iprs_details_verified = false;
        }
        _this2.iprs_verifying = !true;
      }).catch(function (error) {
        _this2.iprs_details_verified = false;
        _this2.iprs_verifying = !true;
        _sweetalert2.default.fire({
          icon: "error",
          text: "We are unable to perform ID verification at the moment. Please try again later. If this error persists, contact customer support"
        });
      });
    },

    confirmIfIdnoAlreadyTaken: function confirmIfIdnoAlreadyTaken(value) {
      var _this3 = this;

      var url = "/api/users/all";
      var payload = {
        search: value,
        type: "search"
      };
      Vue.axios.get(url, { params: payload }).then(function (response) {
        var data = response.data.items;
        if (data.length > 0) {
          _this3.idno_already_taken = false;
        } else {
          _this3.idno_already_taken = true;
        }
      }).catch(function (error) {
        _this3.idno_already_taken = true;
      });
      return this.idno_already_taken;
    },
    confirmIfEmailAlreadyTaken: function confirmIfEmailAlreadyTaken(value) {
      var _this4 = this;

      var url = "/api/users/all";
      var payload = {
        search: value,
        type: this.agent_type
      };
      Vue.axios.get(url, { params: payload }).then(function (response) {
        var data = response.data.items;
        if (data.length > 0) {
          _this4.email_already_taken = false;
        } else {
          _this4.email_already_taken = true;
        }
      }).catch(function (error) {
        _this4.email_already_taken = true;
      });
      return this.email_already_taken;
    },
    confirmIfPhoneAlreadyTaken: function confirmIfPhoneAlreadyTaken(value) {
      var _this5 = this;

      var url = "/api/users/all";
      var payload = {
        search: value,
        type: this.agent_type
      };
      Vue.axios.get(url, { params: payload }).then(function (response) {
        var data = response.data.items;
        if (data.length > 0) {
          _this5.phone_already_taken = false;
        } else {
          _this5.phone_already_taken = true;
        }
      }).catch(function (error) {
        _this5.phone_already_taken = true;
      });
      return this.phone_already_taken;
    },
    confirmMerchantNameAlreadyTaken: function confirmMerchantNameAlreadyTaken(value) {
      var _this6 = this;

      var url = "/api/merchant/find";
      var payload = {
        search: value
      };
      Vue.axios.get(url, { params: payload }).then(function (response) {
        var data = response.data.items;
        if (data.length > 0) {
          _this6.merchant_name_already_taken = false;
        } else {
          _this6.merchant_name_already_taken = true;
        }
      }).catch(function (error) {
        _this6.merchant_name_already_taken = true;
      });
      return this.merchant_name_already_taken;
    },
    onComplete: async function onComplete() {
      var api_url = "/api/self/signup";
      var data = {
        business_name: this.businessForm.bname,
        business_ra_pin: this.businessForm.btaxpin,
        business_reg_no: this.businessForm.bregno,
        dob: "",
        email: this.customerForm.email,
        first_name: this.customerForm.fname,
        gender: "",
        id_number: this.customerForm.idno,
        id_type: "citizen",
        last_name: this.customerForm.lname,
        msisdn: this.customerForm.phone,
        nationality: "",
        other_name: "",
        password: "",
        services: [],

        agent_type: this.agent_type
      };
      var payload = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: (0, _stringify2.default)(data)
      };
      var result = [];

      var _ref = await _sweetalert2.default.fire({
        title: "Terms and conditions",
        input: "checkbox",
        inputValue: 1,
        inputPlaceholder: "I agree with the terms and conditions",
        confirmButtonText: 'Continue&nbsp;<i class="fa fa-arrow-right"></i>',
        showLoaderOnConfirm: true,
        inputValidator: function inputValidator(result) {
          return !result && "You need to agree with T&C";
        },
        preConfirm: function preConfirm() {
          return fetch(api_url, payload).then(function (response) {
            return response.json();
          }).then(function (data) {
            return result.push(data.status);
          }).catch(function () {
            _sweetalert2.default.insertQueueStep({
              icon: "error",
              title: "Unable to process your request"
            });
          });
        }
      }),
          accept = _ref.value;

      if (accept) {
        if (result.toString() == "200") {
          var timerInterval = void 0;
          _sweetalert2.default.fire({
            title: "Registration Sent",
            html: "Please wait, page will be redirected in a few seconds",
            timer: 2500,
            timerProgressBar: true,
            allowOutsideClick: false,
            willOpen: function willOpen() {
              _sweetalert2.default.showLoading();
              timerInterval = setInterval(function () {
                var content = _sweetalert2.default.getContent();
                if (content) {
                  var b = content.querySelector("b");
                  if (b) {
                    b.textContent = _sweetalert2.default.getTimerLeft();
                  }
                }
              }, 100);
            },
            onClose: function onClose() {
              clearInterval(timerInterval);
            }
          }).then(function (result) {
            if (result.dismiss === _sweetalert2.default.DismissReason.timer) {
              window.top.location.href = "/";
            }
          });
        } else {
          _sweetalert2.default.fire({
            icon: "error",
            text: "We are unable to process your request at the moment. If this error persists, kindly contact customer support for further assistance"
          });
        }
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-wizard',{attrs:{"color":"#3498db","error-color":"#ff4949","shape":"tab"},on:{"on-complete":_vm.onComplete}},[_c('h2',{attrs:{"slot":"title"},slot:"title"},[_vm._v("To create an account, complete this wizard")]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Business Details","icon":"ti-settings","before-change":_vm.validateBusinesDetailsStep}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('form',{ref:_vm.businessRuleForm,attrs:{"model":_vm.businessForm,"rules":_vm.rules}},[_c('div',{staticClass:"form-row",class:{ 'form-group--error': _vm.$v.businessForm.bname.$error }},[_c('div',{staticClass:"col-3"},[_c('label',[_vm._v("Business Name")]),_vm._v(" "),(!_vm.$v.businessForm.bname.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  *\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessForm.bname),expression:"businessForm.bname"}],staticClass:"form-control text-uppercase",attrs:{"type":"text","placeholder":"Business Name","maxlength":"30"},domProps:{"value":(_vm.businessForm.bname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessForm, "bname", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.businessForm.bname.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Name must have at least\n                  "+_vm._s(_vm.$v.businessForm.bname.$params.minLength.min)+" letters.\n                ")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',{attrs:{"for":"inputPassword4"}},[_vm._v("UBI")]),_vm._v(" "),(!_vm.$v.businessForm.bregno.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  *\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessForm.bregno),expression:"businessForm.bregno"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Business Registration Number","maxlength":"30"},domProps:{"value":(_vm.businessForm.bregno)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessForm, "bregno", $event.target.value)},_vm.reset_verified]}}),_vm._v(" "),(!_vm.$v.businessForm.bregno.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Reg must have at least\n                  "+_vm._s(_vm.$v.businessForm.bregno.$params.minLength.min)+" letters.\n                ")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.business_verified && _vm.$v.businessForm.bname.alreadyTaken)?_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-12 text-center"},[(_vm.business_verifying)?_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e(),_vm._v("\n                  \n                "),_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.validate_business}},[_vm._v("VERIFY BUSINESS")])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.business_verified)?_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',{attrs:{"for":"inputAddress"}},[_vm._v("Address")]),_vm._v(" "),(!_vm.$v.businessForm.baddr.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  *\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessForm.baddr),expression:"businessForm.baddr"}],staticClass:"form-control text-uppercase",attrs:{"type":"text","maxlength":"40","placeholder":"1234 Nairobi, Kenya"},domProps:{"value":(_vm.businessForm.baddr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessForm, "baddr", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.businessForm.baddr.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Address must have at least\n                  "+_vm._s(_vm.$v.businessForm.baddr.$params.minLength.min)+" letters.\n                ")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.business_verified)?_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',{attrs:{"for":"inputAddress"}},[_vm._v("Business Tax PIN")]),_vm._v(" "),(!_vm.$v.businessForm.btaxpin.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  *\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessForm.btaxpin),expression:"businessForm.btaxpin"}],staticClass:"form-control text-uppercase",attrs:{"type":"text","maxlength":"30","placeholder":"A2903XXXXXXXXXH"},domProps:{"value":(_vm.businessForm.btaxpin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessForm, "btaxpin", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.businessForm.btaxpin.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Tax must have at least\n                  "+_vm._s(_vm.$v.businessForm.btaxpin.$params.minLength.min)+" letters.\n                ")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.business_verified)?_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',{attrs:{"for":"inputAddress"}},[_vm._v("Business Phone No.")]),_vm._v(" "),(!_vm.$v.businessForm.bphone.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  *\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessForm.bphone),expression:"businessForm.bphone"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Phone Number","maxlength":"15"},domProps:{"value":(_vm.businessForm.bphone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessForm, "bphone", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.businessForm.bphone.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Phone must have at least\n                  "+_vm._s(_vm.$v.businessForm.bphone.$params.minLength.min)+" letters.\n                ")]):_vm._e(),_vm._v(" "),(_vm.$v.businessForm.bphone.onlyDigitsAllowed)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Only digits allowed*\n                ")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.business_verified)?_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',[_vm._v("Create Agency ?")])]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agent_type),expression:"agent_type"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"yes","value":"Yes"},domProps:{"checked":_vm._q(_vm.agent_type,"Yes")},on:{"change":function($event){_vm.agent_type="Yes"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"yes"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agent_type),expression:"agent_type"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"no","value":"no"},domProps:{"checked":_vm._q(_vm.agent_type,"no")},on:{"change":function($event){_vm.agent_type="no"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"no"}},[_vm._v("No")])])])]):_vm._e()])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Admin Account Details","icon":"ti-user","before-change":_vm.validateCustomerDetailsStep}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('form',{ref:"ruleForm",attrs:{"model":_vm.customerForm,"rules":_vm.rules}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),(!_vm.$v.customerForm.fname.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  *\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customerForm.fname),expression:"customerForm.fname"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"15","placeholder":"First name"},domProps:{"value":(_vm.customerForm.fname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customerForm, "fname", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.customerForm.fname.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Name must have at least\n                  "+_vm._s(_vm.$v.customerForm.fname.$params.minLength.min)+" letters.\n                ")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),(!_vm.$v.customerForm.lname.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  *\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customerForm.lname),expression:"customerForm.lname"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Last Name","maxlength":"15"},domProps:{"value":(_vm.customerForm.lname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customerForm, "lname", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.customerForm.lname.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Name must have at least\n                  "+_vm._s(_vm.$v.customerForm.lname.$params.minLength.min)+" letters.\n                ")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',[_vm._v("Id Number")]),_vm._v(" "),(!_vm.$v.customerForm.idno.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  *\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customerForm.idno),expression:"customerForm.idno"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Id Number","maxlength":"10"},domProps:{"value":(_vm.customerForm.idno)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.customerForm, "idno", $event.target.value)},_vm.reset_verified]}}),_vm._v(" "),(!_vm.$v.customerForm.idno.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  ID Number must have at least\n                  "+_vm._s(_vm.$v.customerForm.idno.$params.minLength.min)+" letters.\n                ")]):_vm._e(),_vm._v(" "),(!_vm.$v.customerForm.idno.alreadyTaken)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  ID Number already taken\n                ")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),(
                !_vm.iprs_details_verified && _vm.$v.customerForm.idno.alreadyTaken
              )?_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-12 text-center"},[(_vm.iprs_verifying)?_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e(),_vm._v("  \n                "),_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.validate_iprs}},[_vm._v("\n                  VERIFY TO PROCEED\n                ")])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.iprs_details_verified)?_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',[_vm._v("Phone Number")]),_vm._v(" "),(!_vm.$v.customerForm.phone.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  *\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customerForm.phone),expression:"customerForm.phone"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Phone number","maxlength":"12"},domProps:{"value":(_vm.customerForm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customerForm, "phone", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.customerForm.phone.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Phone number must have at least\n                  "+_vm._s(_vm.$v.customerForm.phone.$params.minLength.min)+" letters.\n                ")]):_vm._e(),_vm._v(" "),(!_vm.$v.customerForm.phone.onlyDigitsAllowed)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Only digits allowed*\n                ")]):_vm._e(),_vm._v(" "),(!_vm.$v.customerForm.phone.alreadyTaken)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Phone already registered\n                ")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.iprs_details_verified)?_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',[_vm._v("Email")]),_vm._v(" "),(!_vm.$v.customerForm.email.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  *\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customerForm.email),expression:"customerForm.email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"Email Address","maxlength":"30"},domProps:{"value":(_vm.customerForm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customerForm, "email", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.customerForm.email.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Email must have at least\n                  "+_vm._s(_vm.$v.customerForm.email.$params.minLength.min)+" letters.\n                ")]):_vm._e(),_vm._v(" "),(!_vm.$v.customerForm.email.isValidEmail)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Invalid email should contain an '@'\n                ")]):_vm._e(),_vm._v(" "),(!_vm.$v.customerForm.email.alreadyTaken)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Email already taken\n                ")]):_vm._e()])]):_vm._e()])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Confirm Details","icon":"ti-thumb-up"}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Verify Account Details")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("First Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.customerForm.fname}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Last Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.customerForm.lname}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("ID Number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.customerForm.idno}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Phone Number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.customerForm.phone}})])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Verify Business Details")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Business Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.businessForm.bname}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Business Registration Number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.businessForm.bregno}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Address")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.businessForm.baddr}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Business Tax PIN")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.businessForm.btaxpin}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Business Phone Number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.businessForm.bphone}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Agent Type")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.agent_type}})])])])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Complete Registration","icon":"ti-check"}},[_c('div',{staticClass:"jumbotron jumbotron-fluid"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"display-2"},[_vm._v("Hi "+_vm._s(_vm.customerForm.fname)+",")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n            Click finish to complete the process. Once submitted, you will\n            receive a confirmation email within 24 hrs to activate and be able\n            to use your new account.\n            "),_c('br'),_vm._v("\n            The Pesaflow Team\n          ")])])])])],1)],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8eaf38aa", __vue__options__)
  } else {
    hotAPI.reload("data-v-8eaf38aa", __vue__options__)
  }
})()}